import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Libs
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedPipesModule } from './pipes/pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { SharedComponentsModule } from './components/shared-components.module';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { DatePipe } from '@angular/common';
import { CoreCommonModule } from "../@core/common.module";


@NgModule({
    declarations: [],
    exports: [SharedPipesModule, SharedDirectivesModule, SharedComponentsModule, NgxPermissionsModule, CoreCommonModule], imports: [NgxPermissionsModule.forChild(), CoreCommonModule, SharedPipesModule, SharedDirectivesModule, SharedComponentsModule], providers: [
        DatePipe,
        { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class BaseSharedModule { }
